import React from "react";
import { TextLabel } from "../../components/style";
import moment from "moment";

export default function TableName(props) {
    const { campaign, } = props;

    return (
        <div>
            <div>
                <TextLabel fontWeight="medium">{campaign.campaignName}</TextLabel>
            </div>
            <TextLabel marginBottom="0px" fontSize="13px">
                {`Created ${moment(campaign.created_at).format("Do MMMM, YYYY h:mma")}`}
            </TextLabel>
            <TextLabel marginBottom="0px" fontSize="13px" style={{
                wordWrap: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "normal",
            }}>
                {`by ${campaign.created_by.companyName}`}
            </TextLabel>
        </div>
    );
}
